import {Flex, Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'

import BankLogo from '~/react/components/BankLogo'

const PaymentMethodCell = ({row}) => {
  const debitAgreement = row.original.paymentMethod?.debitAgreement
  const bankName = debitAgreement?.bankName
  const accountNumber = debitAgreement?.accountNumber
  const lastFour = accountNumber?.slice(-4)

  return (
    <Flex alignItems="center" gap="sm">
      <BankLogo providerName={bankName} />
      {lastFour && (
        <>
          <Text whiteSpace="nowrap" fontSize="sm">
            ••••
          </Text>
          <Text whiteSpace="nowrap" fontSize="sm">
            {lastFour}
          </Text>
        </>
      )}
    </Flex>
  )
}

PaymentMethodCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      paymentMethod: PropTypes.shape({
        debitAgreement: PropTypes.shape({
          bankName: PropTypes.string,
          accountNumber: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
}

export default PaymentMethodCell
